export default __webpack_public_path__ + "static/JabezProfilePic-441ab57ea014d35c2329e2f2fd0a31e9.png";